import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Serivce
import ItemService from "../../../services/supplier_appCommonService";

//Components
import Layout from "../../../Layout/Layout";
import Constants from "../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { addRfqCreation } from "../../../redux/feature/supplier_app/sourcingSlice";
import ShowStatus from "../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import ReverseTimer from "../../../Components/TableReverseTimer/ReverseTimer";
import { SearchField } from "../../../Components/formElements/SearchField";
import { currencyFormat, formatDateTime } from "../../../common/Validations";
import { TableStatusField } from "../../../Components/formElements/TableStatusField";
import { MessageCircle } from "lucide-react";
import ChatBox from "../../../Components/ChatBox/ChatBox";
import StickyColumn from "../../../Components/Sticky/StickyColumn";
import { ChartBarIcon, FunnelIcon } from "@heroicons/react/24/solid";
import CommonFillter from "../../../Components/Filter/Supplier/SupplierCommonFillter";
import StatisticsContainer from "../../../Components/Cards/StatisticsCardContainer";
import MultiColumnFilter from "../../../Components/Filter/MultiColumnFilter";
import CreateDocTypeModal from "./CreateDocTypeModal";
import {
  getTenderList,
  tenderNr,
} from "../../../redux/feature/supplier_app/purchasingSlice";
import TableActions from "../../smart_construction_app/Customer_V4/Common/TableActions/TableActions";
const TenderList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Tender");
  localStorage.setItem("submenu", "Tender List");
  let tenderData = useSelector((state) => state?.purchasing?.tender);
  let tenderTable = useSelector(
    (state) => state?.purchasing?.tender.pagination,
  ); // User Details from Store

  // Show Status Modal
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal, setSendDataModal] = useState("");
  const [modelTitle, setModelTitle] = useState("");
  const [data, setData] = useState([]);
  const [showStats, setShowStats] = useState(false);
  const [filterShow, setFilterShow] = useState(false);
  // eslint-disable-next-line
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    if (!showStats) {
      setFilteredData(tenderData.data);
    }
  }, [showStats, tenderData]);

  const handleChartClick = () => {
    setShowStats((prev) => !prev);
  };

  useEffect(() => {
    setData(tenderData?.data || []);
  }, [tenderData]);

  useEffect(() => {
    loadInitialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenderData]);

  // const [loading, setLoading] = useState(false);
  const [isCardVisible, setCardVisible] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [modalData, setModalData] = useState({});
  const [getPurchaseDocType, setPurchaseDocType] = useState("");

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  /* Modal Function */
  const showStatusInfo = (rowData) => {
    setModalShowStatus(true);
    setSendDataModal(rowData);
    setModelTitle("Status Information");
  };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const loadInitialTenderData = async () => {
    setData(tenderData?.data);
  };

  useEffect(() => {
    loadInitialTenderData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenderData]);

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "TenderDocumentList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
    };
    dispatch(getTenderList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [chatId, setChatId] = useState(null);
  const toggleChat = (groupId) => {
    // Toggle the same PR closes the chat
    if (chatId === groupId) {
      setChatId(null);
    } else {
      setChatId(groupId);
    }
  };
  const columns = [
    {
      name: "Collaboration",
      cell: (row) => (
        <>
          <span className="iconTable">
            <button
              onClick={() => toggleChat(row?.userId)}
              title={row?.userId ? "Chat With the User" : "No User Found"}
              // className={`text-sm ${chatId === row.userId ? "text-green-600" : "text-blue-600"} hover:text-blue-800`}
            >
              <MessageCircle className="w-5 h-5" />
            </button>
          </span>
          <span>
            <i className="bi bi-collection-play iconTable"></i>
          </span>
          <span>
            <i className="bi bi-stack iconTable"></i>
          </span>
        </>
      ),
      width: "150px",
    },
    {
      name: "Tender Document Nr",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailTenderNr(row.documentNumber)}
        >
          {row.documentNumber}
        </button>
      ),
    },
    {
      name: "Gem Ref",
      selector: (row) => row.gemReferenceNr,
      sortable: true,
      width: "180px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemLevelShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Version",
      selector: (row) => row.tenderVersion,
      sortable: true,
      width: "100px",
    },
    {
      name: "Title",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold"> {row.tenderTitle} </span>
        </>
      ),
      selector: (row) => row.tenderTitle,
      sortable: true,
      width: "250px",
    },

    // Conditionally include the 'workflowActionLogs' column
    ...(data?.some((row) => row?.workflowActionLogs !== undefined)
      ? [
          {
            name: "Workflow log",
            cell: (row) => (
              <div
                style={{ width: "100%" }}
                className="d-flex justify-content-center iconTable"
              >
                <img
                  src="assets/img/newIcons/workflow.png"
                  alt="attachments"
                  style={{ width: "35px" }}
                  className="mt-1"
                  onClick={() => showStatusInfo(row.workflowActionLogs)}
                />
              </div>
            ),
            sortable: true,
            width: "132px",
          },
        ]
      : []),
    {
      name: "Status",
      selector: (row) => row.tenderHeaderStatus,
      id: "tenderHeaderStatus",
      dropDown: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.tenderHeaderStatus} />
        </>
      ),
      width: "180px",
    },
    // {
    //   name: "Tender Value",
    //   cell: (row) => (
    //     <span className="numberFormate m-0 p-0 pt-1 fw-bold">
    //       {currencyFormat(Number(row.tenderValue).toFixed(2))}
    //     </span>

    //   ),
    //   selector: (row) => row.tenderValue,
    //   sortable: true,
    //   width: "140px",
    // },
    {
      name: "Tender Value",
      selector: (row) => row.tenderValue,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">
            {" "}
            {currencyFormat(Number(row.tenderValue).toFixed(2))}{" "}
          </p>
          <p className="m-0 p-0">{row.tenderCurrency} </p>
        </div>
      ),
    },
    {
      name: "Open Date ",
      selector: (row) => formatDateTime(row.openingDateTime) || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "Close Date",
      selector: (row) => formatDateTime(row.closingDateTime) || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "Countdown Timer",
      cell: (row) => (
        <>
          <ReverseTimer
            closingDateTime={row.closingDateTime}
            openingDateTime={row.openingDateTime}
          />

          {/* <ReverseTimer closingDateTime={0} openingDateTime={0} /> */}
        </>
      ),
      sortable: true,
      width: "270px",
    },
    {
      name: "Procurment Category",
      selector: (row) => row.tndCategoryType,
      id: "tndCategoryType",
      dropDown: true,
      sortable: true,
      width: "200px",
    },
    {
      name: "Bid Type",
      selector: (row) => row.tenderbidTypeCode,
      id: "tenderbidTypeCode",
      dropDown: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.tenderbidTypeCode} />
        </>
      ),
      sortable: true,
      width: "140px",
    },
    ...(data?.some((row) => row?.workflowTECHActionLogs !== undefined)
      ? [
          {
            name: "Flow",
            cell: (row) => (
              <div
                style={{ width: "100%" }}
                className="d-flex justify-content-center iconTable"
                onClick={() => showStatusInfo(row.workflowTECHActionLogs)}
              >
                <i className="bi bi-info-square"></i>
                {/* <img
                  src="assets/img/newIcons/workflow.png"
                  alt="attachments"
                  style={{ width: "35px" }}
                  className="mt-1"
                  onClick={() => showStatusInfo(row.workflowTECHActionLogs)}
                /> */}
              </div>
            ),
            sortable: true,
            width: "80px",
          },
        ]
      : []),
    ...(data?.some((row) => row?.workflowCOMMActionLogs !== undefined)
      ? [
          {
            name: "Flow",
            cell: (row) => (
              <div
                style={{ width: "100%" }}
                className="d-flex justify-content-center iconTable"
                onClick={() => showStatusInfo(row.workflowCOMMActionLogs)}
              >
                <i className="bi bi-info-square"></i>
                {/* <img
                  src="assets/img/newIcons/workflow.png"
                  alt="attachments"
                  style={{ width: "35px" }}
                  className="mt-1"
                  onClick={() => showStatusInfo(row.workflowCOMMActionLogs)}
                /> */}
              </div>
            ),
            sortable: true,
            width: "80px",
          },
        ]
      : []),
    {
      name: "Company",
      id: "companyAddressDesc",
      dropDown: true,
      cell: (row) => (
        <>
          <span> {row.companyAddressDesc} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Buyer Responsible",
      selector: (row) => row.tenderResponsible,
      sortable: true,
      width: "190px",
    },
    {
      name: "Buyer",
      selector: (row) => row.buyerConact,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.tenderResponsible} </p>
          <p className="m-0 p-0 pt-1">{row.buyerConact} </p>
          <p className="m-0 p-0">{row.buyerEmail} </p>
        </div>
      ),
    },
    {
      name: "Envelope Type",
      selector: (row) => row.tenderTypeCategoryDesc,
      sortable: true,
      width: "200px",
    },
    {
      name: "Product",
      selector: (row) => row.productType,
      id: "productType",
      dropDown: true,
      sortable: true,
      width: "150px",
    },
    {
      name: "Action",
      cell: (row) => (
        <TableActions
          actions={[
            {
              label: "Details",
              icon: "bi bi-info-circle",
              iconClass: "text-success",
              bg: "#e6f7ee",
              // onClick: () => showAddProduct("EDIT", row.documentNumber),
            },
            {
              label: "Edit",
              icon: "bi bi-pencil-square",
              iconClass: "text-success",
              bg: "#e6f7ee",
              // onClick: () => showAddProduct("EDIT", row.documentNumber),
            },
            {
              label: "Delete",
              icon: "bi bi-trash",
              iconClass: "text-danger",
              bg: "#fdeaea",
              // onClick: () => deleteMaterial(row),
            },
            {
              label: "More",
              icon: "bi bi-three-dots",
              bg: "#f1f3f5",
              onClick: () => console.log("More", row),
            },
          ]}
        />
      ),
      width: "180px",
    },
  ];
  const handleFilterData = async (filters) => {
    const obj = {
      queryName: "",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };

    dispatch(getTenderList(obj));
  };

  const columnsForFilter = columns
    .filter((col) => col.id || col.selectorKey)
    .map((col) => ({
      name: col.name,
      selectorKey: col.id || col.selectorKey,
      dropDown: col.dropDown || false,
      range: col.range || false,
      month: col.month || false,
    }));

  const LineItemsColInfo = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Material/Service",
      selector: (row) => row.materialCode,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row.materialCode} </p>
            <p className="m-0 p-0">{row.materialDescription} </p>
          </div>
        </>
      ),
      width: "180px",
      sortable: true,
    },
    {
      name: "Material Desc",
      selector: (row) => row.materialGroupDescription,
      sortable: true,
      width: "250px",
    },
    {
      name: "Quantity Unit",
      selector: (row) => row.unit || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Quantity",
      selector: (row) => row.purchaseQuantity,
      sortable: true,
      width: "150px",
    },
    {
      name: "Item Value ", // calculation
      selector: (row) => row.qtnitemValue || "--",
      width: "120px",
    },
  ];

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on Line Item Level Data
  const lineItemLevelShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(LineItemsColInfo);
    setModalTitle("Line Item Level Details");
    setItemLevelModalShow(true);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  /* Modal Function */
  let obj = {
    modalTitle: "Tender",
    navigate: Constants.CREATE_TENDER,
  };
  const createTender = () => {
    setModalData(obj);
    setModalShow(true);
    dispatch(addRfqCreation("Manual"));
  };

  const hideModal = () => {
    setModalShow(false);
  };

  // eslint-disable-next-line no-unused-vars
  const detailedPageVendor = (rfxNr) => {
    dispatch(tenderNr(rfxNr));
    navigate(Constants.SOURCING_VENDOR_RFQ_DETAILS);
  };
  const detailTenderNr = (rfxNr) => {
    dispatch(tenderNr(rfxNr));
    navigate(Constants.TENEDER_DETAILS);
  };

  const loadInitialData = () => {
    setData(tenderData?.data);
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "TenderDocumentList",
      module: "",
      page: page,
      per_page: getNewPerPage,
    };

    dispatch(getTenderList(obj));
    // dispatch(getTenderList({}));
    setData(tenderData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "TenderDocumentList",
      module: "CUSTOMER",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getTenderList(obj));
    setData(tenderData?.data);
  };

  useEffect(() => {
    loadInitialData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenderData]);

  const getMasterData = async () => {
    let obj = {
      codeType: "RFQCategory",
    };
    await ItemService.getMasterData(obj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setPurchaseDocType(item?.data);
      } else {
        setPurchaseDocType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  //on page load
  useEffect(() => {
    getMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getTenderList(obj));
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Tender Requisition</h2>
                <p className="subText">
                  Lists of Tender Requisition and details
                </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <Col xs={12} md={12} lg={12}>
              <Row className="align-items-end justify-content-end">
                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setShowStats(!showStats)}
                    className="icon-btn"
                  >
                    <ChartBarIcon className="icon-svg" />
                  </button>
                </Col>

                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setFilterShow(!filterShow)}
                    className="icon-btn"
                  >
                    <FunnelIcon className="icon-svg" />
                  </button>
                </Col>
              </Row>
            </Col>

            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                // data={data}

                fetchFunction={ItemService.getTenderList}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )}
            <hr />

            {showStats && (
              <div className="stats-box p-3 mb-3 position-relative">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="m-0">Statistics</h5>
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "red",
                    }}
                    onClick={() => setShowStats(false)}
                  >
                    ×
                  </span>
                </div>

                <StatisticsContainer
                  api={ItemService.generateQueryV1}
                  keyName="tenderHeaderStatus"
                  paginatedList={tenderData.data || []}
                  showStats={showStats}
                  onFilter={(data) => setFilteredData(data)}
                  queryName="TenderDocumentList"
                />
              </div>
            )}

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">TR</span>
                    </Col>
                    <Col xs={12} md={5} lg={5}>
                      <span className="headerTitle">TR List</span>
                      <span className="subHeaderTitle">
                        View of Tender Requisition and Status{" "}
                      </span>
                    </Col>
                    <Col xs={2} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => createTender()}
                      >
                        <i className="bi bi-plus-lg"></i> Create Tender
                      </button>
                    </Col>
                    <Col xs={2} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => {
                          alert("asd");
                        }}
                      >
                        <i className="bi bi-x-circle"></i> Cancel
                      </button>
                    </Col>
                    <Col xs="auto" md="auto" lg="auto">
                      <CommonFillter onChartClick={handleChartClick} />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <StickyColumn
                        columnIndexes={[2, 3]}
                        leftOffsets={[0, 120]}
                      />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          // columns={tendorColum}
                          data={filteredData}
                          // data={tenderData}
                          progressPending={tenderData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={tenderTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CreateDocTypeModal
        show={modalShow}
        onHide={() => hideModal()}
        modaldata={modalData}
        dropdowndata={getPurchaseDocType}
        navigate={Constants.SOURCING_CREATE_RFQ}
      />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />

      {chatId && (
        <ChatBox
          groupId={chatId}
          chatTitle="User"
          onClose={() => setChatId(null)}
        />
      )}
    </main>
  );
};

export default TenderList;
